<div class="shop-page">
  <div class="container">
    <ng-container *ngIf="shopExist; else NoShop">
      <app-my-tabs [tabs]="tabs" [defaultTabIndex]="selMenu" (tabChange)="updateSelMenu($event)">
        <div class="my-shop" allTab>
          <div class="nav-product">
            <div class="nav-product__search">
              <input type="text" placeholder="Search for name or description..." />
              <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <div class="left">
              <button class="btn-grid" (click)="viewGrid = true" [ngClass]="{ active: viewGrid }">
                <i class="fa-solid fa-grip-vertical"></i>
              </button>
              <button class="btn-grid" (click)="viewGrid = false" [ngClass]="{ active: !viewGrid }">
                <i class="fa-solid fa-list"></i>
              </button>
              <button class="button-2" (click)="openShopAction('add_product', 0, selectedCategoryName, selectedSubCategoryName)">
                <i class="fa fa-plus" aria-hidden="true"></i>
                <span class="pl-1">Add Product</span>
              </button>
            </div>
          </div>
          <div class="nav-sort">
            <div (click)="sortProducts('name')">
              Name
              <svg viewBox="0 0 800 800" fill="none" [ngClass]="{ active: sortName === 'name' }">
                <path [ngClass]="{ color: sortDirection == 'desc' }" d="M427.135 533.076C413.567 521.143 391.499 522.941 379.565 536.509L253.694 678.4V111.326C253.694 92.6903 238.328 77.3242 219.693 77.3242C201.057 77.3242 185.691 92.6903 185.691 111.326V678.4L59.8198 536.509C46.2519 522.941 25.8182 521.143 12.2503 533.076C-1.31763 546.644 -3.11579 567.078 8.81746 580.646L194.191 788.088C208.086 805.252 232.607 802.637 243.559 788.088L430.568 580.646C442.501 567.241 440.866 545.009 427.135 533.076Z" />
                <path [ngClass]="{ color: sortDirection == 'asc' }" d="M791.181 220.196L607.441 12.7539C591.094 -3.75653 570.661 -4.73734 556.439 12.7539L369.43 220.196C357.497 233.764 359.295 255.832 372.863 267.766C393.787 284.44 414.875 272.997 420.433 264.333L546.304 122.442V687.881C546.304 706.517 561.67 721.883 580.305 721.883C598.941 721.883 614.307 708.315 614.307 689.516V122.605L740.178 264.496C753.746 278.064 774.18 279.862 787.748 267.929C801.316 254.198 803.114 233.764 791.181 220.196Z" />
              </svg>
            </div>
            <div (click)="sortProducts('created')">
              Date
              <svg viewBox="0 0 800 800" fill="none" [ngClass]="{ active: sortName === 'created' }">
                <path [ngClass]="{ color: sortDirection == 'desc' }" d="M427.135 533.076C413.567 521.143 391.499 522.941 379.565 536.509L253.694 678.4V111.326C253.694 92.6903 238.328 77.3242 219.693 77.3242C201.057 77.3242 185.691 92.6903 185.691 111.326V678.4L59.8198 536.509C46.2519 522.941 25.8182 521.143 12.2503 533.076C-1.31763 546.644 -3.11579 567.078 8.81746 580.646L194.191 788.088C208.086 805.252 232.607 802.637 243.559 788.088L430.568 580.646C442.501 567.241 440.866 545.009 427.135 533.076Z" />
                <path [ngClass]="{ color: sortDirection == 'asc' }" d="M791.181 220.196L607.441 12.7539C591.094 -3.75653 570.661 -4.73734 556.439 12.7539L369.43 220.196C357.497 233.764 359.295 255.832 372.863 267.766C393.787 284.44 414.875 272.997 420.433 264.333L546.304 122.442V687.881C546.304 706.517 561.67 721.883 580.305 721.883C598.941 721.883 614.307 708.315 614.307 689.516V122.605L740.178 264.496C753.746 278.064 774.18 279.862 787.748 267.929C801.316 254.198 803.114 233.764 791.181 220.196Z" />
              </svg>
            </div>
            <div (click)="sortProducts('price')">
              Price
              <svg viewBox="0 0 800 800" fill="none" [ngClass]="{ active: sortName === 'price' }">
                <path [ngClass]="{ color: sortDirection == 'desc' }" d="M427.135 533.076C413.567 521.143 391.499 522.941 379.565 536.509L253.694 678.4V111.326C253.694 92.6903 238.328 77.3242 219.693 77.3242C201.057 77.3242 185.691 92.6903 185.691 111.326V678.4L59.8198 536.509C46.2519 522.941 25.8182 521.143 12.2503 533.076C-1.31763 546.644 -3.11579 567.078 8.81746 580.646L194.191 788.088C208.086 805.252 232.607 802.637 243.559 788.088L430.568 580.646C442.501 567.241 440.866 545.009 427.135 533.076Z" />
                <path [ngClass]="{ color: sortDirection == 'asc' }" d="M791.181 220.196L607.441 12.7539C591.094 -3.75653 570.661 -4.73734 556.439 12.7539L369.43 220.196C357.497 233.764 359.295 255.832 372.863 267.766C393.787 284.44 414.875 272.997 420.433 264.333L546.304 122.442V687.881C546.304 706.517 561.67 721.883 580.305 721.883C598.941 721.883 614.307 708.315 614.307 689.516V122.605L740.178 264.496C753.746 278.064 774.18 279.862 787.748 267.929C801.316 254.198 803.114 233.764 791.181 220.196Z" />
              </svg>
            </div>
          </div>
          @if(viewGrid) {
          <div class="my-shop__products-grid">
            <div class="my-shop__products-grid--item" *ngFor="let i of productAllProductListFiltered">
              <img loading="lazy" src="{{ imgUrl }}{{ i?.primaryImage }}" />
              <div>
                <div class="center">
                  <div>
                    <div class="name">
                      {{ i?.name | titlecase }}
                    </div>
                    <div class="date">
                      {{ convertDate(i?.created) }}
                    </div>
                  </div>
                  @if(i.memberShopProductsVariations.length) { @if(isNumber(i.memberShopProductsVariations[0]?.key)) {
                  <div class="desc">{{ i.memberShopProductsVariations[0].key > 0 ? "$" + i.memberShopProductsVariations[0].key : "Free" }}</div>
                  } @else {
                  <div class="desc">
                    {{ i.memberShopProductsVariations[0].key }}
                  </div>
                  } }
                </div>
                <div class="right">
                  <div>
                    <div class="meta" *ngIf="selMenu == 3">
                      <div>
                        <div>{{ typeMask[i.type] | uppercase }}</div>
                        <div class="meta__title">Type</div>
                      </div>
                    </div>
                    <div class="meta">
                      <div>
                        <div>{{ i.categoryName }}</div>
                        <div class="meta__title">Category</div>
                      </div>
                    </div>
                    <div class="meta">
                      <div>
                        <div>{{ i.subCategoryName }}</div>
                        <div class="meta__title">Sub Category</div>
                      </div>
                    </div>
                  </div>
                  <div class="my-shop__products-grid--item__control">
                    <button>
                      <i class="fa fa-pencil" aria-hidden="true" title="Edit" (click)="openShopAction('edit_product', i?.id, i.categoryName, i.subCategoryName)"></i>
                    </button>

                    <button>
                      <i class="fa fa-trash" aria-hidden="true" title="delete" (click)="openShopAction('delete_product', i?.id, i.categoryName, i.subCategoryName)"></i>
                    </button>
                    <app-dropdown-status class="ml-2" size="lg" [value]="i.outOfStockAll == 1 ? 5 : i.status" (change)="onSellOptChange(i, SellProduct, $event)"></app-dropdown-status>

                    <!-- <select *ngIf="selMenu != 3" (change)="onSellOptChange(i, SellProduct, $event.target.value)">
        <option [value]="null" selected>Select</option>
        <option *ngFor="let status of STATUS" [selected]="i.status == status.value" [value]="status.value">{{ status.label }}</option>
        <option [selected]="i.outOfStockAll == 1" value="4">(Out of Stock)</option>
      </select> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          }@else {
          <div class="my-shop__products">
            <div class="my-shop__products--item" *ngFor="let i of productAllProductListFiltered">
              <img loading="lazy" src="{{ imgUrl }}{{ i?.primaryImage }}" />
              <div class="details-name">
                <div class="name">
                  {{ i?.name | titlecase }}
                </div>

                <div class="date">
                  {{ convertDate(i?.created) }}
                </div>
                <div class="desc">${{ i.memberShopProductsVariations[0].key }}</div>
              </div>
              <div class="meta" *ngIf="selMenu == 3">
                <div>
                  <div>{{ typeMask[i.type] | uppercase }}</div>
                  <div class="meta__title">Type</div>
                </div>
              </div>
              <div class="meta">
                <div>
                  <div>{{ i.categoryName }}</div>
                  <div class="meta__title">Category</div>
                </div>
              </div>
              <div class="meta">
                <div>
                  <div>{{ i.subCategoryName }}</div>
                  <div class="meta__title">Sub Category</div>
                </div>
              </div>
              <div class="my-shop__products--item__control">
                <button>
                  <i class="fa fa-pencil" aria-hidden="true" title="Edit" (click)="openShopAction('edit_product', i?.id, i.categoryName, i.subCategoryName)"></i>
                </button>

                <button>
                  <i class="fa fa-trash" aria-hidden="true" title="delete" (click)="openShopAction('delete_product', i?.id, i.categoryName, i.subCategoryName)"></i>
                </button>
                <app-dropdown-status class="ml-2" size="lg" [value]="i.outOfStockAll == 1 ? 5 : i.status" (change)="onSellOptChange(i, SellProduct, $event)"></app-dropdown-status>

                <!-- <select *ngIf="selMenu != 3" (change)="onSellOptChange(i, SellProduct, $event.target.value)">
                  <option [value]="null" selected>Select</option>
                  <option *ngFor="let status of STATUS" [selected]="i.status == status.value" [value]="status.value">{{ status.label }}</option>
                  <option [selected]="i.outOfStockAll == 1" value="4">(Out of Stock)</option>
                </select> -->
              </div>
            </div>
          </div>
          }
        </div>
      </app-my-tabs>
    </ng-container>

    <ng-template #NoShop>
      <section class="no-shop">
        <span>No Shop</span>
        <div class="justify-content-center">
          <button (click)="openShopProfile()" class="btn btn-secondary">Create Shop</button>
        </div>
      </section>
    </ng-template>

    <app-add-shop #AddShop [enableMemberShop]="true" (shopUpdate)="update($event)"> </app-add-shop>

    <ng-template #SellProduct let-modal>
      <div class="modal-body">
        <div class="referral-link">
          <section class="m-4">
            <h3>Change product status to {{ STATUS[selectedSellOption.option].label }} ?</h3>
          </section>
          <div class="mt-5">
            <div class="cart_btn d-flex justify-content-between" style="gap: 2rem">
              <button class="com_btn add-review-btn px-2 w-50" (click)="updateProductStatus()">Yes</button>
              <button class="com_btn add-review-btn px-2 w-50" (click)="modal.dismiss('Cross click')">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
